import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { validateAccessModule } from "../../../../utils/helpers.utils";
import { ACCESS_MODULE, MATRIX_INDICATOR } from '../../../../utils/rbac-constants.utils';
import { ConfirmationNotificationModal } from '../../../common/modal/confirmation-modal.component';
import { MODAL_CUSTOM_MESSAGE, Selected_Index, TABLE_PAGINATION_KEY } from "../../../../constants/external-constants";
import { RequestHeaders } from '../../../common/header-logo/request-header.component';
import { DetailsDashboard } from '../../../common/details-dashboard/details-dashboard-layout';
import { TablePagination } from '../../../common/details-table/table-pagination.component';
import { NoSubscription } from "../../dashboard/no-subscription/no-subscription.component";
import { contractActions } from '../../../../store/external/finance/contract.reducer';
import ContractView from './contract-view/contract-view.component';

class Contract extends Component {
    constructor(props) {
        super(props);
        this.state = {
            displaySearch: false,
            exportAlertMsg: MODAL_CUSTOM_MESSAGE.export_alert_message,
            activeTab: Selected_Index.i_Zero,
            contentIndex: Selected_Index.i_Zero,
            viewDetailPage: false,
            headerTitle: "Contract",
            showCreateNewConfirmationModal: false,
            contractId: 0,
            selectedTab: 0,
            createNew: false,
        }
    }

    componentDidMount() {
        this.props.getContract();
        this.changeHeaderTitle();
    }

    componentWillUnmount() {
        this.props.setDefaultContract();
        this.props.getContract(0, true)
    }

    onClickExtract = (e) => {
        if (window.confirm(this.state.exportAlertMsg)) {
            this.props.extractContract();
        }
    };

    loadingScreen = () => {
        return (
            <NoSubscription />
        );
    }

    displaySearchBox = () => {
        this.setState((prev) => ({ displaySearch: !prev.displaySearch }))
    }

    resizePage = (value) => {
        const { getContract, resizeContractPage } = this.props;
        resizeContractPage(value);
        getContract();
    }

    applyFilter = (isApply, isReset = false) => {
        const { getContract, applyContractFilter } = this.props;
        applyContractFilter(isApply);
        (isApply || isReset) && getContract();
    }

    handleRowClick = () => {
        this.setState(
            { viewDetailPage: true },
            () => {
                const currentViewDetailPage = this.state.viewDetailPage;
                this.changeHeaderTitle(currentViewDetailPage);
            }
        );
    };

    handleCreateNewAction = () => {
        this.setState({
            showCreateNewConfirmationModal: true,
            contractId: 0
        }) 
        this.changeHeaderTitle();
    }

    handleCreateNew = (buttonType) => {
        if (buttonType === "ok") {
            this.setState({
                viewDetailPage: true,
                createNew: !this.state.createNew,
                showCreateNewConfirmationModal: false },
                () => {
                    const currentViewDetailPage = this.state.viewDetailPage;
                    this.changeHeaderTitle(currentViewDetailPage)
                });
        } else {
            this.setState({ showCreateNewConfirmationModal: false })
        }
    }

    handleCloseForm = () => {
        this.setState({
            viewDetailPage: false,
            contractId: 0,
            createNew: false
        }, this.changeHeaderTitle);

        this.props.getContract();
    }

    getData = (isShow, rowItem) => {

        if (rowItem != null) {
            this.setState({
                viewDetailPage: isShow
                , contractId: rowItem.FinanceContractID
            })

            this.setState({ viewDetailPage: isShow }, () => (
                this.changeHeaderTitle()
            ))
        }
        else {
            this.setState({ viewDetailPage: isShow }, this.changeHeaderTitle);
        }

    }

    changeHeaderTitle() {
        if (this.state.viewDetailPage || this.state.createNew) {
            this.setState({ headerTitle: "contract_details_view" })
        } else {
            this.setState({ headerTitle: "Contract" })
        }
    }

    render() {

        const { contract, getContract, setContractColSearchStr, sortContractList, saveContractCustomCols, addContractFilter, removeContractFilter } = this.props;
        const { viewDetailPage, headerTitle, contractId, createNew, displaySearch, showCreateNewConfirmationModal } = this.state;
        const { Selected, Available, Default } = this.props.contract.contractItems.Columns;

        let isReadOnly = !validateAccessModule(MATRIX_INDICATOR.MatrixId, [ACCESS_MODULE.MatrixIdFinanceContractDashboardR])
        let isReadAndExtractOnly = !validateAccessModule(MATRIX_INDICATOR.MatrixId, [ACCESS_MODULE.MatrixIdFinanceContractDashboardRE])
        let isReadAndWrite = !validateAccessModule(MATRIX_INDICATOR.MatrixId, [ACCESS_MODULE.MatrixIdFinanceContractDashboardRW])


        return (
            <div className="invoice-wrapper-container inventory-report-component" >
                <ConfirmationNotificationModal
                    show={showCreateNewConfirmationModal}
                    message={MODAL_CUSTOM_MESSAGE.create_new_contract}
                    title={'Add New'}
                    handleModal={this.handleCreateNew.bind(this)}
                    customClass={'comment-notification-modal modal-text-bold'}
                />

                <RequestHeaders headerTitle={headerTitle} />
                <div className="request-table data-table fit-width">
                    {viewDetailPage ?
                        <ContractView
                            closeFormAction={this.handleCloseForm}
                            contractId={contractId}
                            //getPlanCatalogue={getPlanCatalogue}
                            //Access Type
                            isReadOnly={isReadOnly}
                            isReadAndExtractOnly={isReadAndExtractOnly}
                            isReadAndWrite={isReadAndWrite}
                            isCreateNew = {createNew}

                        />
                        :
                        <>
                    
                        <DetailsDashboard
                            // Filter Properties
                            data={contract.contractItems.TableFilterData}
                            translation={""}
                            addAction={addContractFilter}
                            removeAction={removeContractFilter}
                            applyAction={this.applyFilter}
                            customClassName={"cost-allocation"}

                            //CreateNew Action
                            createNewAction={this.handleCreateNewAction}

                            //View Search Textbox
                            viewSearchAction={this.displaySearchBox}

                            //Customize Column
                            firstList={Available}
                            secondList={Selected}
                            defaultList={Default}
                            saveAction={saveContractCustomCols}

                            //Extract Button
                            extractAction={(e) => this.onClickExtract(e)}

                            //Access Type
                            isReadOnly={isReadOnly}
                            isReadAndExtractOnly={isReadAndExtractOnly}
                            isReadAndWrite={isReadAndWrite}
                        >
                           {
                                contract.isContractLoaded?
                                <TablePagination  
                                    key={TABLE_PAGINATION_KEY.contract}
                                    classNameWrapper="overflow-auto"
                                    columns={contract.contractItems.Headers}
                                    pageList={contract.contractItems.Data}
                                    pages={contract.contractItems.Pagination}
                                    rowClickAction={(value) => {this.getData(true, value)}}
                                    paginationAction={getContract} 
                                    onColumnClick={sortContractList} 
                                    onColumnSearch={() => getContract(0)} 
                                    onColumnSearchChange={setContractColSearchStr} 
                                    isColSearchShow={displaySearch}
                                    resizePage={this.resizePage}
                                    totalPage={contract.contractItems.Pagination.TotalEntries}
                                    hideStatusIcon={true}
                                 />
                                 :
                                 this.loadingScreen()
                            }
                        </ DetailsDashboard >
                     </>
                }
                </div>
            </div>
        )
    }
}

export default withRouter(connect(
    state => {
        const { contract } = state;
        return {
            contract
        };
    },
    dispatch => bindActionCreators(
        Object.assign({}, contractActions),
        dispatch
    )
)(Contract));